import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, mergeMap, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';

import {
  RetailActivityReport,
  RetailActivityReportRequest,
} from 'src/app/core/models/reports/retail-activity.model';
import { OtherReportsService } from 'src/app/core/services/reports/other/other-reports.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { ReportsUtils } from 'src/app/core/utils/reports/reports.utils';
import {
  CONSTS,
  PDF_REPORT,
  REPORT_FILE_NAME,
  RetailActivityFormGroup,
} from './retail-activity-report.constants';

@Component({
  selector: 'app-retail-activity-report',
  templateUrl: './retail-activity-report.component.html',
  styleUrls: ['./retail-activity-report.component.scss'],
  standalone: false,
})
export class RetailActivityReportComponent implements OnInit {
  readonly destroy = inject(DestroyRef);
  readonly input: RetailActivityFormGroup = inject(MAT_DIALOG_DATA);
  private userService = inject(UserService);
  private fb: FormBuilder = inject(FormBuilder);
  private dialogRef: MatDialogRef<RetailActivityReportComponent> = inject(
    MatDialogRef<RetailActivityReportComponent>,
  );
  private otherReportsService: OtherReportsService =
    inject(OtherReportsService);
  private commonUtils: CommonUtils = inject(CommonUtils);
  private reportUtils: ReportsUtils = inject(ReportsUtils);

  readonly CONSTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;
  readonly PDF_REPORT = PDF_REPORT;
  readonly BUTTON_TYPES = BUTTON_TYPES;

  currDate!: Date;
  minDate!: Date;
  maxDate!: Date;
  retailActivityForm!: FormGroup;

  retailActivityReport!: RetailActivityReport;
  @ViewChild('pdfContainer', { read: ViewContainerRef })
  pdfContainer!: ViewContainerRef;

  ngOnInit(): void {
    if (this.input !== null) {
      this.retailActivityForm = this.input;
    }
    this.currDate = new Date();
    this.minDate = new Date(
      this.currDate.getFullYear(),
      this.currDate.getMonth(),
      this.currDate.getDate() - 30,
    );
    this.maxDate = new Date(
      this.currDate.getFullYear(),
      this.currDate.getMonth(),
      this.currDate.getDate() + 14,
    );

    this.retailActivityForm = this.fb.group({
      date: [this.currDate],
    });
  }

  onExit() {
    this.commonUtils.openExitModal(this.retailActivityForm.dirty);
  }

  getReport() {
    this.userService
      .getCurrentUser$()
      .pipe(
        take(1),
        mergeMap((user) => {
          const date = this.retailActivityForm.get('date')?.value;
          const request: RetailActivityReportRequest = {
            locationCode: user?.location,
            date: this.commonUtils.getFormattedDate(date),
          };
          return this.otherReportsService.getRetailActivityReport(request).pipe(
            take(1),
            map((data: RetailActivityReport) => {
              const retailActivityReport = data.response.retailActivity;
              if (retailActivityReport?.length) {
                this.retailActivityReport = data;
                setTimeout(() => {
                  const content =
                    this.pdfContainer.element.nativeElement.innerHTML;
                  this.reportUtils.exportPdfReport(
                    content,
                    PDF_REPORT.NAME,
                    REPORT_FILE_NAME,
                  );
                }, 0);
              } else {
                this.commonUtils.updateBannerType(
                  BANNER_TYPE.NO_DATA_AVAILABLE,
                );
              }

              this.dialogRef.close();
            }),
          );
        }),
      )
      .subscribe();
  }
}
